import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './SubNavbar.css';
import { useSidebar } from '../context/SidebarContext';
import { jwtDecode } from 'jwt-decode'; // ya lo estás usando
import { useSelector } from 'react-redux';
import API_BASE_URL from '../config';
import axios from 'axios';





const SubNavbar = () => {
  const { isCollapsed, setIsCollapsed } = useSidebar();
  const sidebarRef = useRef(null);
  const location = useLocation();

  const token = useSelector((state) => state.auth.token);
  const decodedToken = token ? jwtDecode(token) : null;
  const estacionUsuario = decodedToken?.estacion?.trim().toUpperCase();
  const [serviciosAsignados, setServiciosAsignados] = useState(0);



  const toggleSidebar = () => setIsCollapsed((prev) => !prev);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsCollapsed(true);
    }
  };

  useEffect(() => {
    const fetchServiciosAsignados = async () => {
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const noColaborador = decoded.id;

        const res = await axios.get(`${API_BASE_URL}api/servicios/asignados-hoy/${noColaborador}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setServiciosAsignados(res.data.total);

      } catch (err) {
        console.error("Error al obtener servicios asignados:", err);
      }
    };

    fetchServiciosAsignados();
  }, [token]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  let buttons = [];

  if (location.pathname.startsWith('/kiosko')) {
    buttons = [
      { label: 'Guardias / Corral', path: '/kiosko/guardia', icon: 'fa fa-shield-alt' },
      { label: 'Concluir Servicio', path: '/kiosko/concluir', icon: 'fa fa-check-circle' },
    ];
  } else if (location.pathname.startsWith('/coordinacion')) {
    buttons = [
      { label: 'Aeromexico', path: '/coordinacion/resumenVuelos', icon: 'fa fa-broadcast-tower' },
      //{ label: 'DELTA', path: '/coordinacion/resumenVuelosDL', icon: 'fa fa-broadcast-tower' },
      //{ label: 'AMERICAN AIRLINES', path: '/coordinacion/resumenVuelosAA', icon: 'fa fa-broadcast-tower' },
      //{ label: 'UNITED AIRLINES', path: '/coordinacion/resumenVuelosUA', icon: 'fa fa-broadcast-tower' },
      { label: 'Vuelos Aerolineas', path: '/coordinacion/resumenVuelosIntegrado', icon: 'fa fa-plane-departure' },
      { label: 'Registrados.', path: '/coordinacion/registrados', icon: 'fa fa-user-edit' },
      { label: 'Servicios En espera', path: '/coordinacion/stdby', icon: 'fa fa-pause-circle' },
      { label: 'Guardias', path: '/coordinacion/guardias', icon: 'fa fa-user-shield' },
      { label: 'Rol', path: '/coordinacion/rol', icon: 'fa fa-user' },


      /* { label: 'Geo Zonas', path: '/coordinacion/geozonas', icon: 'fa fa-users-cog' },
      { label: 'Geo Zonas Vistas', path: '/coordinacion/geozonasview', icon: 'fa fa-users-cog' }, */


    ];
  } else if (location.pathname.startsWith('/handheld')) {
    buttons = [
      /*  { label: 'Bitácora', path: '/handheld/bitacora', icon: 'fa fa-book' },
       { label: 'Salidas', path: '/handheld/salidas', icon: 'fa fa-sign-out-alt' },
       { label: 'Llegadas', path: '/handheld/llegadas', icon: 'fa fa-sign-in-alt' },
       { label: 'Gestión', path: '/handheld/gestion', icon: 'fa fa-tasks' },
       { label: 'Gestión T2', path: '/handheld/gestiont2', icon: 'fa fa-user-cog' },
       { label: 'Manual', path: '/handheld/manual', icon: 'fa fa-hands-helping' },
       { label: 'Pendientes', path: '/handheld/pendientes', icon: 'fa fa-hourglass-half' } */
      { label: 'Mis servicios', path: '/handheld/gestion', icon: 'fa fa-book' },
      { label: 'Bitacora', path: '/handheld/bitacora', icon: 'fa fa-edit' },
      { label: 'Salidas', path: '/handheld/salidas', icon: 'fa fa-plane-departure' },
      { label: 'Llegadas', path: '/handheld/llegadas', icon: 'fa fa-plane-arrival' },
    ];
  }

  if (buttons.length === 0) return null;

  const isDisabledBtn = (btn) => {
    if (estacionUsuario === 'MEXT1') {
      return ['/coordinacion/resumenVuelos', '/coordinacion/registrados'].includes(btn.path);
    }
    return false;
  };

  return (
    <>
      <div ref={sidebarRef} className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <button className="toggle-button" onClick={toggleSidebar}>
          <i className={`fa ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
        </button>

        <div className="sidebar-buttons">
          {buttons.map((btn) => {
            const disabled = isDisabledBtn(btn);
            return (
              <Link
                key={btn.path}
                to={disabled ? '#' : btn.path}
                className={`sidebar-button ${disabled ? 'disabled' : ''} ${location.pathname === btn.path ? 'active-nav' : ''}`}
                onClick={disabled ? (e) => e.preventDefault() : undefined}
                aria-disabled={disabled}
                tabIndex={disabled ? -1 : 0}
              >
                {btn.label === 'Aeromexico' ? (
                  <img src={require('../assets/aeromexico.webp')} alt="Aeromexico" className="airline-logo" />
                ) : btn.label === 'DELTA' ? (
                  <img src={require('../assets/delta.png')} alt="Delta" className="airline-logo" />
                ) : btn.label === 'AMERICAN AIRLINES' ? (
                  <img src={require('../assets/AA.jpeg')} alt="American Airlines" className="airline-logo" />
                ) : btn.label === 'UNITED AIRLINES' ? (
                  <img src={require('../assets/UA.jpeg')} alt="United Airlines" className="airline-logo" />
                ) : (
                  <i className={`${btn.icon} sidebar-icon`} />
                )}
                {!isCollapsed && <span>{btn.label}</span>}

                {btn.label === 'Mis servicios' && serviciosAsignados > 0 && (
                  <span className="badge-servicios">{serviciosAsignados}</span>
                )}
              </Link>
            );
          })}
        </div>
      </div>
      {/* Spacer div to push the content */}
      <div className={`sidebar-spacer ${isCollapsed ? 'collapsed' : ''}`}></div>
    </>
  );
};

export default SubNavbar;
